<template>
  <div>
    <button
        v-if="show"
        type="button"
        class="newBlindIcon"
        @click="togglePasswordShow($event, false)"
    >
      {{ $t("blind.hide") }}
    </button>
    <button
        v-else
        type="button"
        class="newBlindIcon"
        @click="togglePasswordShow($event, true)"
    >
      {{ $t("blind.show") }}
    </button>
  </div>
</template>
<script>
export default {
  name: 'SignUpBlindIcon',
  props: {
    index_i: Number
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    togglePasswordShow(event, booleans) {
      this.show = booleans;
      this.$emit('togglePasswordShow', booleans, this.index_i)
    }
  }
}
</script>
<style lang="scss">
.newBlindIcon {
  position: absolute;
  cursor: pointer;
  background-color: var(--grey60);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0);
  color: var(--white);
  width: 60px;
  height: 40px;
  top: 20px;
  right: 0;
  border-radius: 0 3px 3px 0;
}
</style>